<button class="select-events-btn btn btn--white {{ classes }}" (click)="openSelectEventDialog()">
  {{ getButtonLabel(selectedEventIds) }}
</button>
